<template>
    <div>
        正在登录统一门户
    </div>
</template>
<script>
/* eslint-disable */
import * as dd from '@/libs/h5-js-sdk-1.5.28'
export default {
    data(){
        return {
            aa: '',
            titleName: '',
            corpId: ''
        }
    },
    watch: {
        '$route':{
            handler() {
                this.lark(this.corpId)
            },
            deep: true
        }
    },
    created(){
      if (!window.h5sdk) {
        alert('请从飞书打开')
        return
      }
      this.initData()
    },
    mounted() {
      // console.log(tt)
        // this.dindin()
    },
    methods:{
        lark(data) {
          window.h5sdk.ready(() => {
            window.tt.requestAuthCode({
              // 网页应用 App ID
              // appID: "cli_xxx",
              appId: this.corpId,
              scopeList: [],
              success: (res) => {
                this.aa = res
                // 用户授权后返回预授权码
                const { code } = res;
                // let _baseUrl = 'http://127.0.0.1:8090'
                let _baseUrl = window.location.origin
                window.location.href = `${_baseUrl}/sso/feiShu/autoLoginByCode?fromType=mobile&code=${code}`;
              },
              fail: (error) => {
                // 需要额外根据errno判断是否为 客户端不支持requestAccess导致的失败
                const { errno, errString } = error;
                alert(errno)
                alert(errString)
              },
            })
          })
        },
        initData() {
            this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
                const { code, data } = res.data
                const settingLogin = res.data.extra
                if (code === 'OK') {
                    this.corpId = settingLogin.feishu.appid
                    this.lark(this.corpId)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
    }
}
</script>
